import { ExternalSupervisorInvitation } from '../store/types';
import { SuSyApi } from './susyApi';

export const createExternalSupervisorInvitation = async (
    invitationId: string | null,
    invitedBy: string,
    project: string
): Promise<void> => {
    await SuSyApi.post(`/invitation/createExternalSupervisorInvitation`, {
        invitationId,
        invitedBy,
        project,
    });
};

export const cancelExternalSupervisorInvitation = async (
    invitationId: string
): Promise<ExternalSupervisorInvitation> => {
    const { data } = await SuSyApi.post(
        `/invitation/cancelExternalSupervisorInvitation`,
        {
            invitationId,
        }
    );

    return data;
};

export const validateExternalSupervisorRegistrationCompletionCode = async (
    code: string
): Promise<boolean> => {
    const { data } = await SuSyApi.get(
        `/invitation/validateExternalSupervisorRegistrationCompletionCode/${code}`
    );

    return data;
};

export const getExternalInvitationByProject = async (
    projectId: string | null
): Promise<Array<ExternalSupervisorInvitation>> => {
    const { data } = await SuSyApi.get(`/invitation/project/${projectId}`);

    return data;
};

export const getAllDeclinedExternalSupervisorInvitationsByAdmin =
    async (): Promise<Array<ExternalSupervisorInvitation>> => {
        const { data } = await SuSyApi.get(
            `/invitation/externalSupervisor/decline/all`
        );
        return data;
    };
